export class Retraction {
    nodes;
    edges;
    constructor(nodes, edges) {
        this.nodes = nodes;
        this.edges = edges;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmV0cmFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvcmVjb3JkL1JldHJhY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxPQUFPLFVBQVU7SUFDWixLQUFLLENBQW1CO0lBQ3hCLEtBQUssQ0FBbUI7SUFFakMsWUFBWSxLQUF3QixFQUFFLEtBQXdCO1FBQzVELElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO1FBQ2xCLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBQ3BCLENBQUM7Q0FDRiJ9